export default "__VITE_ASSET__e1690e9b__"